<nav class="navbar py-0">

  <ng-container *ngIf="isParitalLogin">
    <ng-container *ngTemplateOutlet="showParitalLogon"></ng-container>
  </ng-container>

  <ng-container *ngIf="isFullLogin">
    <ng-container *ngTemplateOutlet="showFullLogon"></ng-container>
  </ng-container>


</nav>

<ng-template #showParitalLogon>
  <button (click)="logoff()" [ngStyle]="UIUtilityService.getBankButtonStyle()" class="font-header-login-signout" mat-button>
    {{ "SIGN_OUT_BTN" | translate }}
  </button>
</ng-template>

<ng-template #showFullLogon>
  <button *ngIf="this.showQr" type="button" [ngStyle]="UIUtilityService.getHeaderStyle()" class="btn btn-white d-flex align-items-center px-0" routerLink="/qr-main">
    <mat-icon svgIcon="farQRCode"></mat-icon><span class="d-none d-md-inline-block font-header-login-control" [ngStyle]="UIUtilityService.getHeaderStyle()">&nbsp; {{
      "LABEL_QRCODE" | translate }} &nbsp;</span>
  </button>  
  <button type="button" [ngStyle]="UIUtilityService.getHeaderStyle()" class="btn btn-white d-flex align-items-center px-0" routerLink="/settings/personal">
    <mat-icon svgIcon="fasCog"></mat-icon><span class="d-none d-md-inline-block font-header-login-control" [ngStyle]="UIUtilityService.getHeaderStyle()">
      &nbsp; {{ "LABEL_SETTINGS" | translate }}</span>
  </button>
  <button type="button" [ngStyle]="UIUtilityService.getHeaderStyle()" class="btn btn-white d-flex align-items-center" routerLink="/support-center">
    <mat-icon svgIcon="falInfoCircle"></mat-icon><span class="d-none d-md-inline-block font-header-login-control" [ngStyle]="UIUtilityService.getHeaderStyle()">&nbsp; {{
      "LABEL_SUPPORT_CENTER" | translate }} &nbsp;</span>
  </button>
  <button (click)="logoff()" [ngStyle]="UIUtilityService.getBankButtonStyle()" class="font-header-login-signout" mat-button>
    {{ "SIGN_OUT_BTN" | translate }}
  </button>
</ng-template>